export const homeAnimations = {
  '@keyframes slideFromLeft': {
    from: {
      opacity: 0,
      transform: 'translateX(-300px) translateZ(0)'
    },
    to: {
      opacity: 1,
      transform: 'translateX(0) translateZ(0)'
    }
  },
  '@keyframes slideFromTop': {
    from: {
      opacity: 0,
      transform: 'translateY(-300px) translateZ(0)'
    },
    to: {
      opacity: 1,
      transform: 'translateY(0) translateZ(0)'
    }
  },
  '@keyframes slideFromRight': {
    from: {
      opacity: 0,
      transform: 'translateX(300px) translateZ(0)'
    },
    to: {
      opacity: 1,
      transform: 'translateX(0) translateZ(0)'
    }
  },
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 }
  },
  '@keyframes slideAndFadeInFromLeft': {
    '0%': {
      opacity: 0,
      transform: 'translateX(-100px) scale(0.9) translateZ(0)'
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0) scale(1) translateZ(0)'
    }
  },
  '@keyframes slideAndFadeInFromRight': {
    '0%': {
      opacity: 0,
      transform: 'translateX(100px) scale(0.9) translateZ(0)'
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0) scale(1) translateZ(0)'
    }
  },
  '@keyframes moveIconFromLeft': {
    '0%': {
      opacity: 0,
      transform: 'translate(-300%, -50%) translateZ(0)'
    },
    '70%': {
      opacity: 1
    },
    '100%': {
      opacity: 1,
      transform: 'translate(-50%, -50%) translateZ(0)'
    }
  },
  '@keyframes moveIconFromRight': {
    '0%': {
      opacity: 0,
      transform: 'translate(200%, -50%) translateZ(0)'
    },
    '70%': {
      opacity: 1
    },
    '100%': {
      opacity: 1,
      transform: 'translate(-50%, -50%) translateZ(0)'
    }
  },
  '@keyframes moveIconFromTop': {
    '0%': {
      opacity: 0,
      transform: 'translate(-50%, -300%) translateZ(0)'
    },
    '70%': {
      opacity: 1
    },
    '100%': {
      opacity: 1,
      transform: 'translate(-50%, -50%) translateZ(0)'
    }
  }
}; 